// // import React, { useState, useEffect } from 'react';
// // import {
// //   Dialog, DialogTitle, DialogContent, DialogActions,
// //   Box, Typography, TextField, Button, Autocomplete,
// //   CircularProgress, Alert, Chip,
// // } from '@mui/material';
// // import api from '../../../api/axiosInterceptor';
// // import { submitForwardReturn } from './workflowApi';

// // // AC is the one role that may reassign the Case Worker while forwarding
// // // (doc: "may assign a new Case Worker if necessary").
// // const ForwardReturnDialog = ({ open, onClose, excessId, refId, role, currentStage, stageLabel, onSuccess, onError }) => {
// //   const [remarks, setRemarks] = useState('');
// //   const [submitting, setSubmitting] = useState(false);
// //   const [caseWorkers, setCaseWorkers] = useState([]);
// //   const [selectedCaseWorker, setSelectedCaseWorker] = useState(null);
// //   const [loadingUsers, setLoadingUsers] = useState(false);

// //   const isAC = role === 'assistant_commissioner';

// //   useEffect(() => {
// //     if (!open || !isAC) return;
// //     setLoadingUsers(true);
// //     api.get('/auth/role-mgmt/')
// //       .then((res) => {
// //         const list = Array.isArray(res.data) ? res.data : res.data?.users || [];
// //         setCaseWorkers(list);
// //       })
// //       .catch(() => setCaseWorkers([]))
// //       .finally(() => setLoadingUsers(false));
// //   }, [open, isAC]);

// //   const reset = () => {
// //     setRemarks('');
// //     setSelectedCaseWorker(null);
// //   };

// //   const handleClose = () => {
// //     if (submitting) return;
// //     reset();
// //     onClose();
// //   };

// //   const handleAction = async (actionType) => {
// //     try {
// //       setSubmitting(true);
// //       await submitForwardReturn(excessId, {
// //         actionType,
// //         remarks,
// //         newCaseWorkerId: isAC && actionType === 'forward' ? selectedCaseWorker?.id : undefined,
// //       });
// //       onSuccess(actionType === 'forward' ? 'Case forwarded successfully.' : 'Case sent back successfully.');
// //       reset();
// //       onClose();
// //     } catch (err) {
// //       onError(err?.response?.data?.error || 'Failed to update the case.');
// //     } finally {
// //       setSubmitting(false);
// //     }
// //   };

// //   return (
// //     <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
// //       <DialogTitle>Review Case — {refId}</DialogTitle>
// //       <DialogContent>
// //         <Box mb={2}>
// //           <Chip label={stageLabel} color="warning" size="small" sx={{ fontWeight: 600 }} />
// //         </Box>

// //         <TextField
// //           label="Remarks"
// //           fullWidth
// //           multiline
// //           rows={3}
// //           value={remarks}
// //           onChange={(e) => setRemarks(e.target.value)}
// //           placeholder="Notes for the next reviewer, or reason for sending back..."
// //           sx={{ mb: 2 }}
// //         />

// //         {isAC && (
// //           <Box mb={1}>
// //             <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
// //               Reassign Case Worker (optional)
// //             </Typography>
// //             <Autocomplete
// //               options={caseWorkers}
// //               loading={loadingUsers}
// //               getOptionLabel={(u) => (u.name ? `${u.name} (${u.email})` : u.email || '')}
// //               value={selectedCaseWorker}
// //               onChange={(_, val) => setSelectedCaseWorker(val)}
// //               renderInput={(params) => (
// //                 <TextField
// //                   {...params}
// //                   size="small"
// //                   placeholder="Leave blank to keep the current Case Worker"
// //                   InputProps={{
// //                     ...params.InputProps,
// //                     endAdornment: (
// //                       <>
// //                         {loadingUsers ? <CircularProgress size={16} /> : null}
// //                         {params.InputProps.endAdornment}
// //                       </>
// //                     ),
// //                   }}
// //                 />
// //               )}
// //             />
// //           </Box>
// //         )}

// //         <Alert severity="info" sx={{ mt: 2 }}>
// //           <strong>Forward</strong> moves this case to the next stage.{' '}
// //           <strong>Return</strong> sends it back for correction — no errors should pass this stage.
// //         </Alert>
// //       </DialogContent>
// //       <DialogActions>
// //         <Button onClick={handleClose} disabled={submitting}>Cancel</Button>
// //         <Button
// //           onClick={() => handleAction('return')}
// //           color="warning"
// //           variant="outlined"
// //           disabled={submitting}
// //         >
// //           Return
// //         </Button>
// //         <Button
// //           onClick={() => handleAction('forward')}
// //           variant="contained"
// //           disabled={submitting}
// //           startIcon={submitting ? <CircularProgress size={16} color="inherit" /> : null}
// //         >
// //           {submitting ? 'Submitting...' : 'Forward'}
// //         </Button>
// //       </DialogActions>
// //     </Dialog>
// //   );
// // };

// // export default ForwardReturnDialog;


// import React, { useState, useEffect } from 'react';
// import {
//   Dialog, DialogTitle, DialogContent, DialogActions,
//   Box, Typography, TextField, Button, Autocomplete,
//   CircularProgress, Alert, Chip,
// } from '@mui/material';
// import api from '../../../api/axiosInterceptor';
// import { submitForwardReturn } from './workflowApi';

// // AC is the one role that may reassign the Case Worker while forwarding
// // (doc: "may assign a new Case Worker if necessary").
// const ForwardReturnDialog = ({ open, onClose, excessId, refId, role, currentStage, stageLabel, onSuccess, onError }) => {
//   const [remarks, setRemarks] = useState('');
//   const [submitting, setSubmitting] = useState(false);
//   const [caseWorkers, setCaseWorkers] = useState([]);
//   const [selectedCaseWorker, setSelectedCaseWorker] = useState(null);
//   const [loadingUsers, setLoadingUsers] = useState(false);

//   const isAC = role === 'assistant_commissioner';
//   const isCA = role === 'competent_authority';
//   const isSploca = role === 'sploca';

//   const forwardLabel = isCA
//     ? 'Approve & Send to SPLOCA'
//     : isSploca
//       ? 'Finalize & Send to Payment'
//       : 'Forward';

//   useEffect(() => {
//     if (!open || !isAC) return;
//     setLoadingUsers(true);
//     api.get('/auth/role-mgmt/')
//       .then((res) => {
//         const list = Array.isArray(res.data) ? res.data : res.data?.users || [];
//         setCaseWorkers(list);
//       })
//       .catch(() => setCaseWorkers([]))
//       .finally(() => setLoadingUsers(false));
//   }, [open, isAC]);

//   const reset = () => {
//     setRemarks('');
//     setSelectedCaseWorker(null);
//   };

//   const handleClose = () => {
//     if (submitting) return;
//     reset();
//     onClose();
//   };

//   const handleAction = async (actionType) => {
//     try {
//       setSubmitting(true);
//       await submitForwardReturn(excessId, {
//         actionType,
//         remarks,
//         newCaseWorkerId: isAC && actionType === 'forward' ? selectedCaseWorker?.id : undefined,
//       });
//       onSuccess(actionType === 'forward' ? 'Case forwarded successfully.' : 'Case sent back successfully.');
//       reset();
//       onClose();
//     } catch (err) {
//       onError(err?.response?.data?.error || 'Failed to update the case.');
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
//       <DialogTitle>Review Case — {refId}</DialogTitle>
//       <DialogContent>
//         <Box mb={2}>
//           <Chip label={stageLabel} color="warning" size="small" sx={{ fontWeight: 600 }} />
//         </Box>

//         <TextField
//           label="Remarks"
//           fullWidth
//           multiline
//           rows={3}
//           value={remarks}
//           onChange={(e) => setRemarks(e.target.value)}
//           placeholder="Notes for the next reviewer, or reason for sending back..."
//           sx={{ mb: 2 }}
//         />

//         {isAC && (
//           <Box mb={1}>
//             <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
//               Reassign Case Worker (optional)
//             </Typography>
//             <Autocomplete
//               options={caseWorkers}
//               loading={loadingUsers}
//               getOptionLabel={(u) => (u.name ? `${u.name} (${u.email})` : u.email || '')}
//               value={selectedCaseWorker}
//               onChange={(_, val) => setSelectedCaseWorker(val)}
//               renderInput={(params) => (
//                 <TextField
//                   {...params}
//                   size="small"
//                   placeholder="Leave blank to keep the current Case Worker"
//                   InputProps={{
//                     ...params.InputProps,
//                     endAdornment: (
//                       <>
//                         {loadingUsers ? <CircularProgress size={16} /> : null}
//                         {params.InputProps.endAdornment}
//                       </>
//                     ),
//                   }}
//                 />
//               )}
//             />
//           </Box>
//         )}

//         <Alert severity="info" sx={{ mt: 2 }}>
//           {isCA && (
//             <>Approving hands this case to <strong>SPLOCA</strong> for final sign-off — it will drop out of your queue.</>
//           )}
//           {isSploca && (
//             <>Finalizing sends this straight to <strong>Payment Processing</strong> — this is the last approval step.</>
//           )}
//           {!isCA && !isSploca && (
//             <><strong>Forward</strong> moves this case to the next stage. <strong>Return</strong> sends it back for correction — no errors should pass this stage.</>
//           )}
//         </Alert>
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={handleClose} disabled={submitting}>Cancel</Button>
//         <Button
//           onClick={() => handleAction('return')}
//           color="warning"
//           variant="outlined"
//           disabled={submitting}
//         >
//           Return
//         </Button>
//         <Button
//           onClick={() => handleAction('forward')}
//           variant="contained"
//           disabled={submitting}
//           startIcon={submitting ? <CircularProgress size={16} color="inherit" /> : null}
//         >
//           {submitting ? 'Submitting...' : forwardLabel}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default ForwardReturnDialog;

import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Box, Typography, TextField, Button, Autocomplete,
  CircularProgress, Alert, Chip,
} from '@mui/material';
import api from '../../../api/axiosInterceptor';
import { submitForwardReturn } from './workflowApi';

// AC is the one role that may reassign the Case Worker while forwarding
// (doc: "may assign a new Case Worker if necessary").
const ForwardReturnDialog = ({ open, onClose, excessId, refId, role, currentStage, stageLabel, onSuccess, onError }) => {
  const [remarks, setRemarks] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [caseWorkers, setCaseWorkers] = useState([]);
  const [selectedCaseWorker, setSelectedCaseWorker] = useState(null);
  const [loadingUsers, setLoadingUsers] = useState(false);

  const isAC = role === 'assistant_commissioner';
  const isCA = role === 'competent_authority';
  const isSploca = role === 'sploca';

  const forwardLabel = isCA
    ? 'Forward to SPLOCA'
    : isSploca
      ? 'Finalize & Send to Payment'
      : 'Forward';

  useEffect(() => {
    if (!open || !isAC) return;
    setLoadingUsers(true);
    api.get('/auth/role-mgmt/')
      .then((res) => {
        const list = Array.isArray(res.data) ? res.data : res.data?.users || [];
        setCaseWorkers(list);
      })
      .catch(() => setCaseWorkers([]))
      .finally(() => setLoadingUsers(false));
  }, [open, isAC]);

  const reset = () => {
    setRemarks('');
    setSelectedCaseWorker(null);
  };

  const handleClose = () => {
    if (submitting) return;
    reset();
    onClose();
  };

  const ACTION_MESSAGES = {
    return: 'Case sent back successfully.',
    forward: isCA ? 'Case forwarded to SPLOCA for final sign-off.' : 'Case forwarded successfully.',
    finalize: 'Case finalized — sent directly to Payment Processing.',
  };

  const handleAction = async (actionType) => {
    try {
      setSubmitting(true);
      await submitForwardReturn(excessId, {
        actionType,
        remarks,
        newCaseWorkerId: isAC && actionType === 'forward' ? selectedCaseWorker?.id : undefined,
      });
      onSuccess(ACTION_MESSAGES[actionType] || 'Case updated successfully.');
      reset();
      onClose();
    } catch (err) {
      onError(err?.response?.data?.error || 'Failed to update the case.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Review Case — {refId}</DialogTitle>
      <DialogContent>
        <Box mb={2}>
          <Chip label={stageLabel} color="warning" size="small" sx={{ fontWeight: 600 }} />
        </Box>

        <TextField
          label="Remarks"
          fullWidth
          multiline
          rows={3}
          value={remarks}
          onChange={(e) => setRemarks(e.target.value)}
          placeholder="Notes for the next reviewer, or reason for sending back..."
          sx={{ mb: 2 }}
        />

        {isAC && (
          <Box mb={1}>
            <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
              Reassign Case Worker (optional)
            </Typography>
            <Autocomplete
              options={caseWorkers}
              loading={loadingUsers}
              getOptionLabel={(u) => (u.name ? `${u.name} (${u.email})` : u.email || '')}
              value={selectedCaseWorker}
              onChange={(_, val) => setSelectedCaseWorker(val)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  placeholder="Leave blank to keep the current Case Worker"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loadingUsers ? <CircularProgress size={16} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </Box>
        )}

        <Alert severity="info" sx={{ mt: 2 }}>
          {isCA && (
            <>
              As Competent Authority you can either <strong>Forward to SPLOCA</strong> (SPLOCA
              gives the final sign-off) or <strong>Finalize</strong> it yourself right now — you
              are the final approver either way; SPLOCA is only involved if you choose to forward.
            </>
          )}
          {isSploca && (
            <>Finalizing sends this straight to <strong>Payment Processing</strong> — this is the last approval step.</>
          )}
          {!isCA && !isSploca && (
            <><strong>Forward</strong> moves this case to the next stage. <strong>Return</strong> sends it back for correction — no errors should pass this stage.</>
          )}
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={submitting}>Cancel</Button>
        <Button
          onClick={() => handleAction('return')}
          color="warning"
          variant="outlined"
          disabled={submitting}
        >
          Return
        </Button>
        {isCA && (
          <Button
            onClick={() => handleAction('finalize')}
            color="success"
            variant="outlined"
            disabled={submitting}
          >
            Finalize (I'm the Final Approver)
          </Button>
        )}
        <Button
          onClick={() => handleAction('forward')}
          variant="contained"
          disabled={submitting}
          startIcon={submitting ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {submitting ? 'Submitting...' : forwardLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ForwardReturnDialog;